import { getSettingChatWorkingHours } from "@faire/help-center-utils/settings/getSettingChatWorkingHours";
import { getSettingPhoneWorkingHours } from "@faire/help-center-utils/settings/getSettingPhoneWorkingHours";
import invert from "lodash/invert";
var TIMEZONE;
(function (TIMEZONE) {
  TIMEZONE["EST"] = "America/New_York";
  TIMEZONE["GMT"] = "Europe/London";
})(TIMEZONE || (TIMEZONE = {}));
var formatTo12Hour = function formatTo12Hour(hours) {
  var adjustedHours = hours % 12;
  if (adjustedHours === 0) {
    adjustedHours = 12;
  }
  return "".concat(adjustedHours);
};
// @ts-prune-ignore-next
export var getFormattedWorkingHours = function getFormattedWorkingHours(_ref) {
  var start_at = _ref.start_at,
    end_at = _ref.end_at,
    timezone = _ref.timezone;
  if (!start_at || !end_at || !timezone) {
    return {
      formattedStartHours: undefined,
      formattedEndHours: undefined,
      formattedTimezone: undefined
    };
  }
  var startHours = start_at / (1000 * 60 * 60);
  var endHours = end_at / (1000 * 60 * 60);
  var formattedStartHours = formatTo12Hour(startHours);
  var formattedEndHours = formatTo12Hour(endHours);
  var timezoneMap = invert(TIMEZONE);
  var formattedTimezone = timezoneMap[timezone];
  return {
    formattedStartHours: formattedStartHours,
    formattedEndHours: formattedEndHours,
    formattedTimezone: formattedTimezone
  };
};
export var getSupportWorkingHours = function getSupportWorkingHours(supportType) {
  var workingHoursSetting;
  if (supportType === "chat") {
    workingHoursSetting = getSettingChatWorkingHours();
  } else {
    workingHoursSetting = getSettingPhoneWorkingHours();
  }
  return getFormattedWorkingHours(workingHoursSetting);
};